export default __webpack_public_path__ + "static/media/icon_folder.71d9658f.svg";